export default "__VITE_ASSET__010c94ca__"